import { SegmentedControl } from './SegmentedControl';

const VIEW_MODES = ['Chart', 'Grid'] as const;
export type ViewMode = (typeof VIEW_MODES)[number];

// Chart/Grid switch for a Trends card header. Chart is the default: the grid
// is one tap away and still holds every number.
export function ViewToggle({ value, onChange }: { value: ViewMode; onChange: (v: ViewMode) => void }) {
  return <SegmentedControl options={VIEW_MODES} value={value} onChange={onChange} label="View" />;
}
